import { useQuery } from '@tanstack/react-query';
import { deerEndpoints } from 'Deer/constants/endpoints';
import { sendRequest } from 'api/sendRequest';

const fetchVisierStatus = async () => {
  try {
    const url = deerEndpoints.visierSyncStatus;
    // @ts-expect-error queryparams in required in sendRequest
    const res = await sendRequest({
      url,
      credentials: 'include',
      method: 'GET',
    });
    return res.entity;
  } catch (error) {
    console.error('Error fetching visier sync status', error);
    throw new Error('Error fetching visier sync status');
  }
};

export const useVisierSyncStatus = () => {
  const { data, isLoading, isError } = useQuery(['visierSyncStatus'], () => fetchVisierStatus());

  return {
    data,
    isLoading,
    isError,
  };
};
